/**
 * site-webapp — Routes Configuration
 *
 * Auth/session routes (login, forgot-password, magic-link landing, org-switch)
 * plus the Site Builder routes from src/site/routes.js. The auth route paths
 * match flex2-webapp exactly so emailed links (magic login, forgot-password)
 * keep working against this host.
 */
import { lazy } from "react";

import siteRoutes from "site/routes";

const LoginScreen = lazy(() => import("pages/Login"));
const ForgotPassword = lazy(() => import("pages/ForgotPassword"));
const AuthCheck = lazy(() => import("pages/AuthCheck"));
const SwitchOrg = lazy(() => import("pages/SwitchOrg"));

const routes = [
  {
    name: "Login Page",
    key: "loginPage",
    route: "/login",
    component: <LoginScreen />,
  },
  {
    name: "Forgot Password",
    key: "forgotPassword",
    route: "/forgot-password",
    component: <ForgotPassword />,
  },
  {
    name: "Magic Login",
    key: "magic-login",
    route: "/auth-check",
    component: <AuthCheck />,
  },
  {
    name: "Switching Organization",
    key: "switching-organization",
    route: "/switch-org",
    component: <SwitchOrg />,
  },
  ...siteRoutes,
];

export default routes;
